<template>
  <section class="cart">
    <header class="cart__header">
      <img
        :src="walletImageSrc"
        alt="Apple Wallet"
        width="160"
      >
    </header>

    <div class="cart__content">
      <div class="cart__ticket">
        <section class="cart-table">
          <header class="cart-table__row cart-table__row--header cart-table__row--download">
            <span class="cart-table__type">
              <small>{{ $t('table.type') }}</small>
            </span>
            <span class="cart-table__download">
              <small>{{ $t('table.wallet') }}</small>
            </span>
          </header>

          <template v-if="hasAnyTickets">
            <div
              v-for="(ticket, index) in tickets"
              :key="index"
              class="cart-table__row"
            >
              <span class="cart-table__type">
                Ticket {{ index + 1 }}: {{ articleTypes[$i18n.locale][ticket.typeId] }}
              </span>
              <span class="cart-table__download">
                <span class="cart-table__download-button">
                  <action @click="downloadWallet(ticket.barcode.barcode)">
                    {{ $t('table.download') }}
                  </action>
                </span>
              </span>
            </div>
          </template>

          <template v-if="hasAnyTours">
            <div
              v-for="(ticket, index) in tours"
              :key="index"
              class="cart-table__row"
            >
              <span class="cart-table__type">
                {{ $t('table.tour') }} {{ index + 1 }}: {{ articleTypes[$i18n.locale][ticket.typeId] }}
              </span>
              <span class="cart-table__download">
                <span class="cart-table__download-button">
                  <action @click="downloadWallet(ticket.barcode.barcode)">
                    {{ $t('table.download') }}
                  </action>
                </span>
              </span>
            </div>
          </template>

          <template v-if="hasAnyEvents && articlesLoaded">
            <div
              v-for="(event, index) in events"
              :key="index"
              class="cart-table__row"
            >
              <span class="cart-table__type">
                Ticket {{ ticketCount + index + 1 }}: {{ articles[event.typeId]['title_' + $i18n.locale] }}
              </span>
              <span class="cart-table__download">
                <span class="cart-table__download-button">
                  <action @click="downloadWallet(event.barcode.barcode)">
                    {{ $t('table.download') }}
                  </action>
                </span>
              </span>
            </div>
          </template>

          <template v-if="hasAnyVouchers">
            <header class="cart-table__row cart-table__row--header cart-table__row--download">
              <span class="cart-table__type">
                <small>{{ $t('table.vouchers') }}</small>
              </span>
            </header>

            <div
              v-for="(barcodes_for_type, typeId) in orderData.vouchers.articles"
              :key="typeId"
              class="cart-table__row"
            >
              <span class="cart-table__type">
                <strong>{{ barcodes_for_type.length }}x</strong> {{ voucherTitle(typeId) }}
              </span>
              <span class="cart-table__download">
                <span class="cart-table__download-button">
                  <action @click="downloadWallet(firstVoucher.barcode)">
                    {{ $t('table.download') }}
                  </action>
                </span>
              </span>
            </div>
          </template>
        </section>
      </div>

      <p><small>{{ $t('wallet.trademark') }}</small></p>
    </div>
  </section>
</template>

<script>
import action from './action.vue'

import { BASE_URL, API_URL } from '../settings.js'

import api from '../api.js'
import cartMixin from '../mixins/cart.js'

export default {
  name: 'CCartBookingWallet',

  components: {
    action
  },

  mixins: [cartMixin],

  props: {
    orderData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      articlesLoaded: false,
      articles: {}
    }
  },

  computed: {
    firstVoucher () {
      return Object.values(this.orderData.vouchers.articles)[0][0]
    },

    firstEvent () {
      return Object.values(this.orderData.events.articles)[0][0]
    },

    hasAnyTickets () {
      for (const i in this.orderData.tickets.articles) {
        if (i in this.orderData.tickets.articles) {
          return true
        }
      }
      return false
    },

    ticketCount () {
      let result = 0
      for (const i in this.orderData.tickets.articles) {
        if (i in this.orderData.tickets.articles) {
          result += this.orderData.tickets.articles[i].length
        }
      }
      return result
    },

    hasAnyTours () {
      for (const i in this.orderData.tours.articles) {
        if (i in this.orderData.tours.articles) {
          return true
        }
      }
      return false
    },

    hasAnyEvents () {
      for (const i in this.orderData.events.articles) {
        if (i in this.orderData.events.articles) {
          return true
        }
      }
      return false
    },

    hasAnyVouchers () {
      for (const i in this.orderData.vouchers.articles) {
        if (i in this.orderData.vouchers.articles) {
          return true
        }
      }
      return false
    },

    referenceId () {
      return this.$store.state.orderReference || this.$route.params.referenceid
    },

    tickets () {
      const tickets = []

      for (const typeId in this.orderData.tickets.articles) {
        const barcodesForType = this.orderData.tickets.articles[typeId]

        for (const barcodeId in barcodesForType) {
          const barcode = barcodesForType[barcodeId]
          tickets.push({ typeId, barcode })
        }
      }

      return tickets
    },

    tours () {
      const tours = []

      for (const typeId in this.orderData.tours.articles) {
        const barcodesForType = this.orderData.tours.articles[typeId]

        for (const barcodeId in barcodesForType) {
          const barcode = barcodesForType[barcodeId]
          tours.push({ typeId, barcode })
        }
      }

      return tours
    },

    events () {
      const events = []

      for (const typeId in this.orderData.events.articles) {
        const barcodesForType = this.orderData.events.articles[typeId]

        for (const barcodeId in barcodesForType) {
          const barcode = barcodesForType[barcodeId]
          events.push({ typeId, barcode })
        }
      }

      return events
    },

    walletImageSrc () {
      return `${BASE_URL}static/img/apple-wallet-${this.$i18n.locale}.svg`
    }
  },

  created () {
    this.loadArticles()
  },

  methods: {
    loadArticles () {
      if (this.hasAnyEvents) {
        const articleIds = []
        for (const typeId in this.orderData.events.articles) {
          articleIds.push(typeId)
        }

        api.get('events/articles/?ids=' + articleIds.join(',')).then(response => {
          for (const index in response.data) {
            const article = {
              id: response.data[index].id,
              title_de: response.data[index].text_de,
              title_en: response.data[index].text_en
            }
            this.articles[response.data[index].id] = article
          }

          this.articlesLoaded = true
        })
      }
    },

    downloadWallet (barcode) {
      const downloadUrl = `${API_URL}download/${this.referenceId}-${barcode}/wallet/`
      window.open(downloadUrl)
    },

    voucherTitle: function (voucherId) {
      const vouchers = this.$store.state.vouchers
      for (const voucherGroup in vouchers) {
        for (const voucherIndex in vouchers[voucherGroup]) {
          if (vouchers[voucherGroup][voucherIndex].id === parseInt(voucherId)) {
            return (this.$i18n.locale === 'de') ? vouchers[voucherGroup][voucherIndex].text : vouchers[voucherGroup][voucherIndex].text_en
          }
        }
      }
      return ''
    }
  }
}
</script>

<i18n locale="en">
{
  "table": {
    "quantity": "Qty",
    "type": "Ticket Type",
    "events": "Special Events",
    "vouchers": "Vouchers",
    "wallet": "Download Wallet",
    "download": "Download",
    "tour": "Experience"
  },
  "wallet": {
    "trademark": "Apple and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries."
  }
}
</i18n>

<i18n locale="de">
{
  "table": {
    "type": "Ticketart",
    "events": "Sonderveranstaltungen",
    "vouchers": "Gutscheine",
    "wallet": "Wallet-Download",
    "download": "Herunterladen",
    "tour": "Erlebnis"
  },
  "wallet": {
    "trademark": "Apple und iPhone sind Marken der Apple Inc., die in den USA und weiteren Ländern eingetragen sind."
  }
}
</i18n>
